if (!customElements.get('bn-privacy-controls')) {
  customElements.define('bn-privacy-controls', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.error = this.querySelector('[data-privacy-error]');
      this.api = () => window.Shopify?.customerPrivacy;
      this.open = () => {
        if (!this.api() || this.dialog.open) return;
        const consent = this.api().currentVisitorConsent();
        for (const purpose of ['analytics', 'marketing', 'preferences']) {
          this.form.elements[purpose].checked = consent[purpose] === 'yes';
        }
        const gpc = navigator.globalPrivacyControl === true;
        this.form.elements.sale_opt_out.checked = gpc || !this.api().saleOfDataAllowed();
        this.form.elements.sale_opt_out.disabled = gpc;
        this.querySelector('[data-gpc]').hidden = !gpc;
        this.error.hidden = true;
        if (this.optIn) this.dialog.show();
        else this.dialog.showModal();
      };
      this.refresh = () => {
        if (!this.api() || !window.AttributionPrivacy) return;
        // Preview the California controls without changing Shopify's real region or tracking permissions.
        const previewCalifornia = new URLSearchParams(window.location.search).get('test') === 'california';
        this.california = previewCalifornia || window.AttributionPrivacy.region() === 'USCA';
        this.optIn = !previewCalifornia && window.AttributionPrivacy.requiresOptIn();
        this.dialog.classList.toggle('bn-privacy__dialog--corner', this.optIn);
        this.querySelector('[data-privacy-footer]').hidden = !this.california && !this.optIn;
        this.querySelectorAll('[data-california-copy]').forEach(node => { node.hidden = !this.california; });
        this.querySelectorAll('[data-opt-in-copy]').forEach(node => { node.hidden = !this.optIn; });
        if (!this.california && !this.optIn) { this.dialog.close(); return; }
        const consent = this.api().currentVisitorConsent();
        const undecided = ['analytics', 'marketing', 'preferences'].some(key => !['yes', 'no'].includes(consent[key]));
        if (this.optIn && undecided && !this.prompted) { this.prompted = true; this.open(); }
      };
      this.querySelector('[data-open-privacy]').addEventListener('click', this.open, options);
      this.querySelector('[data-close-privacy]').addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('[data-accept]').addEventListener('click', () => this.save({ analytics: true, marketing: true, preferences: true }), options);
      this.querySelector('[data-reject]').addEventListener('click', () => this.save({ analytics: false, marketing: false, preferences: false }), options);
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        this.save(this.california
          ? { sale_of_data: navigator.globalPrivacyControl !== true && !this.form.elements.sale_opt_out.checked }
          : Object.fromEntries(['analytics', 'marketing', 'preferences'].map(key => [key, this.form.elements[key].checked])));
      }, options);
      document.addEventListener('attribution:privacy-ready', this.refresh, options);
      document.addEventListener('visitorConsentCollected', this.refresh, options);
      this.refresh();
    }
    save(consent) {
      if (this.saving || !this.api()) return;
      this.saving = true;
      this.error.hidden = true;
      const buttons = this.querySelectorAll('.bn-privacy__actions button');
      buttons.forEach(button => { button.disabled = true; });
      const finish = error => {
        clearTimeout(this.saveTimeout);
        this.saving = false;
        buttons.forEach(button => { button.disabled = false; });
        if (error) { this.error.textContent = this.dataset.error; this.error.hidden = false; }
        else this.dialog.close();
      };
      this.saveTimeout = setTimeout(() => finish(true), 10000);
      try { this.api().setTrackingConsent(consent, result => finish(result?.error)); }
      catch (_) { finish(true); }
    }
    disconnectedCallback() {
      this.events?.abort();
      clearTimeout(this.saveTimeout);
    }
  });
}
